/**
 * FN-FIX-A1 — MoneyInput: penz-beviteli mezo HUF formatummal
 *
 * - value: HUF szam (pl. 3000)
 * - onChange: HUF szam callback
 * - Megjelenes: szokozokkel tagolt (3 000 Ft)
 * - Mobile: inputMode="numeric"
 */
import { useState, useEffect, useRef } from 'react';

interface MoneyInputProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

function formatDisplay(n: number): string {
  if (n === 0) return '';
  return new Intl.NumberFormat('hu-HU').format(n);
}

function parseInput(raw: string): number {
  // Strip spaces, replace comma with dot
  const cleaned = raw.replace(/\s/g, '').replace(',', '.');
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
}

export default function MoneyInput({ value, onChange, label, placeholder = '0', className = '', disabled = false }: MoneyInputProps) {
  const [editing, setEditing] = useState(false);
  const [rawText, setRawText] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!editing) {
      setRawText(formatDisplay(value));
    }
  }, [value, editing]);

  function handleFocus() {
    setEditing(true);
    // Show raw number for editing
    setRawText(value ? String(value) : '');
    // Select all text after focus
    setTimeout(() => inputRef.current?.select(), 0);
  }

  function handleBlur() {
    setEditing(false);
    const parsed = parseInput(rawText);
    onChange(parsed);
    setRawText(formatDisplay(parsed));
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setRawText(e.target.value);
    const parsed = parseInput(e.target.value);
    onChange(parsed);
  }

  return (
    <div className={className}>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <div className="relative">
        <input
          ref={inputRef}
          type="text"
          inputMode="numeric"
          value={rawText}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          disabled={disabled}
          className="form-input pr-8"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm pointer-events-none">Ft</span>
      </div>
    </div>
  );
}
